// extracted by mini-css-extract-plugin
module.exports =  {"container":"---src-components-VideoEventDetails-SidePanel-FinalReview__container--u5z92","select":"---src-components-VideoEventDetails-SidePanel-FinalReview__select--aQs6B"};